module.exports = __webpack_public_path__ + "images/花筑院子全景_08-3.jpg?v=aca1d354";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_08-3.jpg
 ** module id = 83
 ** module chunks = 1 2
 **/